import UploadComponent from "../DataSets/UploadComponent"
import { useState, useEffect, useRef, useMemo } from 'react';
import { useNavigate } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FileUpload } from "primereact/fileupload";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { DateFormatter } from "../../utils/DateFormatter";
import { Checkbox } from "primereact/checkbox";
import { TreeTable } from "primereact/treetable";
import { InputText } from "primereact/inputtext";
import { Tag } from "primereact/tag";
import { ProgressSpinner } from 'primereact/progressspinner';
import { Dropdown } from "primereact/dropdown";

export default function Upload() {
    const [files, setFiles] = useState([]);
    const [filesToUpload, setFilesToUpload] = useState([]);
    const [unassignedFiles, setUnassignedFiles] = useState([]);
    const uploadRef = useRef();
    const [uploading, setUploading] = useState(false);
    const [visible1, setVisible1] = useState(false);
    const [visible2, setVisible2] = useState(false);
    const [addFileTypesVisible, setAddFileTypesVisible] = useState(false);
    const [samples, setSamples] = useState([]);
    const [fileSelection, setFileSelection] = useState(new Set());
    const [sampleNodes, setSampleNodes] = useState([]);
    const [sampleInput, setSampleInput] = useState('');
    const [selectedNodeKey, setSelectedNodeKey] = useState(null);
    const [existingSampleNodes, setExistingSampleNodes] = useState([]);
    const [filesToExistingSamples, setFilesToExistingSamples] = useState({});
    const [fileTypeMap, setFileTypeMap] = useState([]);
    const [filePropMap, setFilePropMap] = useState([]);
    
    const navigate = useNavigate();


    const getDataUserToken = JSON.parse(sessionStorage.getItem('apitoken'));

    const fileTypesValid = useMemo(() => {
        if (!filesToUpload?.files?.length) return false;
        if (fileTypeMap.length < filesToUpload.files.length) return false;
        for (let i = 0; i < fileTypeMap.length; i++) {
            const type = fileTypeMap[i];
            if (type === undefined) return false;
            if (type === 'Paired End') {
                if (filePropMap[i] !== 'Forward' && filePropMap[i] !== 'Reverse') return false;
            }
            if (type === 'Pacbio') {
                if (filePropMap[i] !== 'bam' && filePropMap[i] !== 'pbi') return false;
            }
        }
        return true;
    }, [filePropMap, fileTypeMap, filesToUpload]);

    const headers = {
        Authorization: `Bearer ${getDataUserToken}`,
    };

    useEffect(() => {
        document.title = 'Data -> Upload Files | Palmona Pathogenomics'
    }, []);

    function getSessionStorageOrDefault(key, defaultValue) {
        const stored =  sessionStorage.getItem(key);
        if (!stored) {
          return defaultValue;
        }
        return JSON.parse(stored);
    
    }

    const [userid] = useState(
        getSessionStorageOrDefault('userid', null)
    );
    const groupIds = JSON.parse(sessionStorage.getItem('usergroups'));

    useEffect(() => {
        fetch(process.env.REACT_APP_WORKFLOW_API_PATH + 'wfapi/sample?userId=' + userid, {
            method: 'GET',
            headers,
        })
            .then(res => res.json())
            .then(data => {
                setSamples(data);
            });
    }, []);

    useEffect(() => {
        if (!samples.length || existingSampleNodes.length) return;
        const newExistingSampleNodes = samples.map((sample, i) => {
            const sampleNode = {
                key: String(i),
                data: sample,
                type: 'sample',
                children: []
            };
            sample.files.forEach((file, j) => {
                sampleNode.children.push({
                    key: `${i}-${j}`,
                    data: file,
                    type: 'file',
                    existing: true,
                });
            });
            return sampleNode;
        });
        setExistingSampleNodes(newExistingSampleNodes);
    }, [samples])

        
    const uploadFiles = () => {
        const successFiles = [];
        const failureFiles = [];
        const addedNames = new Set();
        setUploading(true);
        setAddFileTypesVisible(false)
        filesToUpload.files.forEach((file, i) => {
            const form = new FormData();
            form.append('ownerId', userid);
            form.append('file', file);
            form.append('groupId', groupIds);

            // comment this out to test table without file upload
            fetch(process.env.REACT_APP_WORKFLOW_API_PATH + 'wfapi/file', {
                method: 'POST',
                headers,
                body: form
            })
                .then(res => res.json())
                .then(conf => {
                    file.uploadedAt = conf.createdAt;
                    file.id = conf.id;
                    const newUploadedFiles = uploadRef.current.getUploadedFiles();
                    newUploadedFiles.push(file);
                    uploadRef.current.setUploadedFiles(newUploadedFiles);
                    const newPendingFiles = uploadRef.current.getFiles().filter(oldFile => oldFile.name !== file.name && !addedNames.has(oldFile.name));
                    uploadRef.current.setFiles(newPendingFiles);
                    successFiles.push(file);
                    setFiles([...files, file]);
                    if (successFiles.length + failureFiles.length === filesToUpload.files.length) {
                        setUploading(false);
                        setFiles([...files, ...successFiles]);
                    }
                    addedNames.add(file.name);
                    let typeVal;
                    switch (fileTypeMap[i]) {
                        case 'Paired End':
                            typeVal = 'paired_end';
                            break;
                        case 'Pacbio':
                            typeVal = 'pacbio';
                            break;
                        case 'Fasta':
                            typeVal = 'fasta';
                            break;
                        case 'Single End':
                            typeVal = 'single_end';
                            break;
                        default:
                            typeVal = ''
                    }

                    // add file attributes
                    const typeForm = new FormData();
                    typeForm.append('name', 'type');
                    typeForm.append('value', typeVal);
                    typeForm.append('fileId', file.id);
                    fetch(process.env.REACT_APP_WORKFLOW_API_PATH + 'wfapi/file_attribute' , {
                        method: 'POST',
                        headers,
                        body: typeForm
                    })
                        // .then(res => res.json())
                        // .then(typeConf => console.log('typeconf', typeConf));
                    if (typeVal === 'paired_end' || typeVal === 'pacbio') {
                        const propForm = new FormData();
                        propForm.append('name', typeVal === 'paired_end' ? 'direction' : 'pbfile');
                        propForm.append('value', filePropMap[i]);
                        propForm.append('fileId', file.id);
                        fetch(process.env.REACT_APP_WORKFLOW_API_PATH + 'wfapi/file_attribute' , {
                            method: 'POST',
                            headers,
                            body: propForm
                        })
                            // .then(res => res.json())
                            // .then(dirConf => console.log('propconf', dirConf));
                    }   
                })
                .catch(err => {
                    console.error('failed to upload file', err);
                    failureFiles.push(file);
                });

            // uncomment this to test table without file upload
            // setTimeout(() => {
            //     file.uploadedAt = new Date().toTimeString();
            //     file.id = 670;
            //     const newUploadedFiles = uploadRef.current.getUploadedFiles();
            //     newUploadedFiles.push(file);
            //     uploadRef.current.setUploadedFiles(newUploadedFiles);
            //     const newPendingFiles = uploadRef.current.getFiles().filter(oldFile => oldFile.name !== file.name && !addedNames.has(oldFile.name));
            //     uploadRef.current.setFiles(newPendingFiles);
            //     successFiles.push(file);
            //     if (successFiles.length + failureFiles.length === inputFiles.files.length) {
            //         setUploading(false);
            //         setFiles([...files, ...successFiles]);
            //     }
            //     addedNames.add(file.name);
            //     console.log(file);
            // }, 3000);
            
        })
        
    }

    const updateFileSelction = (i, checked) => {
        const newFileSelection = new Set(fileSelection);
        if (checked) newFileSelection.add(i);
        else newFileSelection.delete(i);
        setFileSelection(newFileSelection);
    }

    const fileSelectorTemplate = (file, props) => {
        return <Checkbox checked={fileSelection.has(props.rowIndex)} onChange={e => updateFileSelction(props.rowIndex, e.checked)}/>
    }

    const dateTemplate = item => {
        if (item.type === 'file') return;
        return DateFormatter(item.data.updatedAt);
    }

    const removeTemplate = (item, mode) => {
        if (mode === 'existing'){
            if (item.type === 'sample' || item.existing === true) return;
            return <Button rounded text severity="danger" icon="pi pi-times" onClick={() => removeExistingItem(item)}/>
        } 
        return <Button rounded text severity="danger" icon="pi pi-times" onClick={() => removeItem(item)}/>
    }

    const itemTemplate = (item, props) => {
        const uploadedFiles = uploadRef.current.getUploadedFiles();
        const completed = Boolean(uploadedFiles.find(file => file.id === item.id));
        return (
            <div className="flex align-items-center flex-wrap">
                <div className="flex align-items-center" style={{ width: '20%' }}>
                    <span className="flex flex-column text-left ml-3">
                        {item.name}
                        <small>{new Date().toLocaleDateString()}</small>
                    </span>
                </div>
                <Tag value={props.formatSize} severity={completed ? 'success' : 'warning'} className="px-3 py-2" />
                {!uploading && !completed && <Button disabled={uploading || completed} type="button" icon="pi pi-times" className="p-button-outlined p-button-rounded p-button-danger ml-auto" onClick={() => props.onRemove()} />}
                {uploading && !completed && <ProgressSpinner style={{width: '30px', height: '30px'}} className='ml-auto'/>}
            </div>
        )
    }

    const removeItem = (item) => {
        if (item.type === 'sample') {
            const newSampleNodes = [...sampleNodes];
            newSampleNodes.splice(item.key, 1);
            const newUnassignedFiles = [...unassignedFiles];
            item.children.forEach(child => { 
                newUnassignedFiles.push(child.data.file);
            });
            newSampleNodes.forEach((node, i) => {
                node.key = String(i);
                node.children.forEach((child, j) => {
                    child.key = `${i}-${j}`
                });
            });
            setUnassignedFiles(newUnassignedFiles);
            setSampleNodes(newSampleNodes);
        }
        if (item.type === 'file') {
            const newSampleNodes = [...sampleNodes];
            const dashInd = item.key.indexOf('-');
            const newSample = newSampleNodes[item.key.slice(0, dashInd)];
            newSample.children.splice(item.key.slice(dashInd + 1), 1);
            newSample.children.forEach((child, i) => {
                child.key = `${item.key.slice(0, dashInd)}-${i}`
            });
            const newUnassignedFiles = [...unassignedFiles];
            newUnassignedFiles.push(item.data.file);
            setUnassignedFiles(newUnassignedFiles);
            setSampleNodes(newSampleNodes);
        }
    }

    const removeExistingItem = item => {
        const newSampleNodes = [...existingSampleNodes];
        const dashInd = item.key.indexOf('-');
        const newSample = newSampleNodes[item.key.slice(0, dashInd)];
        newSample.children.splice(item.key.slice(dashInd + 1), 1);
        newSample.children.forEach((child, i) => {
            child.key = `${item.key.slice(0, dashInd)}-${i}`
        });
        const newUnassignedFiles = [...unassignedFiles];
        newUnassignedFiles.push(item.data.file);
        setUnassignedFiles(newUnassignedFiles);
        setExistingSampleNodes(newSampleNodes);
    }

    const attachFile = (sampleId, fileIds) => {
        
        return Promise.all(fileIds.map(id => {
            const form = new FormData();
            form.append('fileId', id);
            return fetch(process.env.REACT_APP_WORKFLOW_API_PATH + 'wfapi/sample/' + sampleId, {
                method: 'PATCH',
                headers,
                body: form
            })
                .then(res => res.json());
        }))
            .then(() => sampleId);
    }

    const associateFilesToExisting = () => {
        Object.entries(filesToExistingSamples).forEach(([sampleNodeId, files]) => {
            attachFile(samples[sampleNodeId].id, files.map(file => file.id));
        })
    }

    const addSampleName = () => {
        setSampleInput('');
        const newSampleNodes = [...sampleNodes];
        newSampleNodes.push({
            key: String(sampleNodes.length),
            data: {
                name: sampleInput,
            },
            type: 'sample',
            children: []
        });
        setSampleNodes(newSampleNodes);
    }

    const openSampleGeneration = () => {
        const newSampleNodes = [...sampleNodes];
        // tracks where in the array each sample is
        const newSampleNames = {};
        const newUnassignedFiles = [];
        if (!sampleNodes.length) {
            files.forEach(file => {
                if (file.name.match(/.*_.*\.fastq\.gz$/g)) {
                    let sampleName;
                    if (file.name.match(/.*_.*_.*[1-2]_.*\.fastq\.gz$/g)) {
                        sampleName = file.name.slice(0, file.name.indexOf('_'))
                    } else {
                        sampleName = file.name.slice(0, file.name.lastIndexOf('_'))
                    }
                    if (Object.hasOwn(newSampleNames, sampleName)) {
                        newSampleNodes[newSampleNames[sampleName]].children.push({
                            key: `${newSampleNames[sampleName]}-${newSampleNodes[newSampleNames[sampleName]].children.length}`,
                            data: {
                                name: file.name,
                                file: file
                            },
                            type: 'file'
                        });
                    } else {
                        const sampleNode = {
                            key: String(newSampleNodes.length),
                            data: {
                                name: sampleName,
                            },
                            children: [],
                            type: 'sample'
                        }
                        sampleNode.children.push({
                            key: `${sampleNode.key}-${sampleNode.children.length}`,
                            data: {
                                name: file.name,
                                file: file
                            },
                            type: 'file'
                        })
                        newSampleNames[sampleName] = newSampleNodes.length;
                        newSampleNodes.push(sampleNode);
                    }
                } else {
                    newUnassignedFiles.push(file);
                }
            });
        }
        setUnassignedFiles(newUnassignedFiles);
        setSampleNodes(newSampleNodes);
        setVisible2(true);
    }

    const openSampleAssociation = () => {
        const assignedFiles = new Set();
        Object.values(filesToExistingSamples).forEach(fileArr => {
            fileArr.forEach(file => {
                assignedFiles.add(file.id);
            })
        });
        const newUnassignedFiles = files.filter(file => !assignedFiles.has(file.id));
        setUnassignedFiles(newUnassignedFiles);
        setVisible1(true);
    }

    const uploadGeneratedSamples = () => {
        Promise.all(sampleNodes.map(sampleNode => {
            const form = new FormData();
            form.append('name', sampleNode.data.name);
            form.append('ownerId', userid);
            form.append('groupId', groupIds);
            return fetch(process.env.REACT_APP_WORKFLOW_API_PATH + 'wfapi/sample', {
                method: 'POST',
                headers,
                body: form
            })
                .then(res => res.json())
                .then(conf => attachFile(conf.id, sampleNode.children.map(child => child.data.file.id)));
        }))
            .then(ids => {
                // nav to sample list
                navigate('/datasets/list_samples', {
                    state: {
                        sampleids: ids
                    }
                });
            })
        // setVisible2(false);

    }

    const onEditorValueChange = (options, value) => {
        let newNodes = [...sampleNodes];
        newNodes[options.rowIndex].data.name = value;
        newNodes[options.rowIndex].label = value;
        setSampleNodes(newNodes);
    };

    const sampleNameEditor = options => {
        if (options.node.key.includes('-')) return options.value;
        return <InputText type="text" value={options.value} onChange={(e) => onEditorValueChange(options, e.target.value)} />;
    }

    const assignFilesToGeneratedSample = () => {
        const truncatedNodeKey = selectedNodeKey.includes('-') ? selectedNodeKey.slice(0, selectedNodeKey.indexOf('-')) : selectedNodeKey;
        const newSampleNodes = [...sampleNodes];
        const selectedNode = newSampleNodes[truncatedNodeKey];
        fileSelection.forEach(i => {
            selectedNode.children.push({
                key: `${truncatedNodeKey}-${selectedNode.children.length}`,
                data: {
                    name: unassignedFiles[i].name,
                    file: unassignedFiles[i],
                    type: 'file'
                }
            });
        });
        const newUnassignedFiles = unassignedFiles.filter((file, i) => !fileSelection.has(i));
        setUnassignedFiles(newUnassignedFiles);
        setFileSelection(new Set());
        setSampleNodes(newSampleNodes);
    }

    const assignFilesToExistingSample = () => {
        const truncatedNodeKey = selectedNodeKey.includes('-') ? selectedNodeKey.slice(0, selectedNodeKey.indexOf('-')) : selectedNodeKey;
        const newSampleNodes = [...existingSampleNodes];
        const selectedNode = newSampleNodes[truncatedNodeKey];
        const newFilesToExistingSamples = {...filesToExistingSamples};
        fileSelection.forEach(i => {
            selectedNode.children.push({
                key: `${truncatedNodeKey}-${selectedNode.children.length}`,
                data: {
                    name: unassignedFiles[i].name,
                    file: unassignedFiles[i],
                    existing: false
                },
                type: 'file'
            });
            if (!newFilesToExistingSamples[truncatedNodeKey]) {
                newFilesToExistingSamples[truncatedNodeKey] = [];
            }
            newFilesToExistingSamples[truncatedNodeKey].push(unassignedFiles[i]);
        });
        const newUnassignedFiles = unassignedFiles.filter((file, i) => !fileSelection.has(i));
        setUnassignedFiles(newUnassignedFiles);
        setFileSelection(new Set());
        setExistingSampleNodes(newSampleNodes);
        setFilesToExistingSamples(newFilesToExistingSamples);
    }

    const requiredValidator = (e) => {
        let props = e.columnProps;
        let value = props.node.data[props.field];

        return value && value.length > 0;
    };

    const fileTypeOptions = ['Paired End', 'Pacbio', 'Fasta', 'Single End'];
    const pairedEndOptions = ['Forward', 'Reverse'];
    const pacbioOptions = ['bam', 'pbi'];

    const modifyFileTypeMap = (i, val) => {
        const newFileTypeMap = [...fileTypeMap];
        newFileTypeMap[i] = val;
        setFileTypeMap(newFileTypeMap);
    }

    const modifyFilePropMap = (i, val) => {
        const newFilePropMap = [...filePropMap];
        newFilePropMap[i] = val;
        setFilePropMap(newFilePropMap);
    }

    const typeSelectionTemplate = (item, props) => {
        return (
            <>
                <Dropdown options={fileTypeOptions} value={fileTypeMap[props.rowIndex]} onChange={e => modifyFileTypeMap(props.rowIndex, e.value)}/>
                {/* extra options for paired end */}
                {fileTypeMap[props.rowIndex] === 'Paired End' && <Dropdown options={pairedEndOptions} value={filePropMap[props.rowIndex]} onChange={e => modifyFilePropMap(props.rowIndex, e.value)} />}
                {/* extra options for pacbio */}
                {fileTypeMap[props.rowIndex] === 'Pacbio' && <Dropdown options={pacbioOptions} value={filePropMap[props.rowIndex]} onChange={e => modifyFilePropMap(props.rowIndex, e.value)} />}
            </>
            
        )
    }

    const openFileTypeWindow = (inputFiles) => {
        setFilesToUpload(inputFiles);
        const fileTypeGuess = [];
        const filePropGuess = [];
        // logic to guess file types based on names
        inputFiles.files.forEach((file, i) => {
            // imported from old guesser
            if (file.name.match(/.*_.*_.*1_.*\.fastq\.gz$/g)) {
                fileTypeGuess[i] = 'Paired End';
                filePropGuess[i] = 'Forward';
            } 
            else if (file.name.match(/.*_.*_.*2_.*\.fastq\.gz$/g)) {
                fileTypeGuess[i] = 'Paired End';
                filePropGuess[i] = 'Reverse';
            }
            else if (file.name.match(/1\.fastq\.gz$/g) || file.name.match(/1\.fq\.gz$/g)) {
                fileTypeGuess[i] = 'Paired End';
                filePropGuess[i] = 'Forward';
            }
            else if (file.name.match(/2\.fastq\.gz$/g) || file.name.match(/2\.fq\.gz$/g)) {
                fileTypeGuess[i] = 'Paired End';
                filePropGuess[i] = 'Reverse';
            }
            else if (file.name.match(/\.bam$/g)) {
                fileTypeGuess[i] = 'Pacbio'
                filePropGuess[i] = 'bam'
            }
            else if (file.name.match(/\.pbi$/g)) {
                fileTypeGuess[i] = 'Pacbio'
                filePropGuess[i] = 'pbi'
            }
            else if (file.name.match(/\.fasta$/g)) {
                fileTypeGuess[i] = 'Fasta';
            }
            else {
                fileTypeGuess[i] = undefined;
            }
        })

        setFileTypeMap(fileTypeGuess);
        setFilePropMap(filePropGuess);
        setAddFileTypesVisible(true);
    }

    return (
        <div>
            {uploading && <div className="alert alert-primary" role="alert">
                Upload in progress, please remain on this page until upload is completed.
            </div>}
            <h1>Upload Files</h1>
            <ol type="1">
                <li>Choose files to upload or drag and drop into the box below</li>
                <li>Click “upload” to select file types and upload files</li>
                <li>Click one of the three buttons on the bottom right to finish</li>
            </ol>
            <FileUpload ref={uploadRef} name="demo[]" accept=".gz" uploadHandler={openFileTypeWindow} customUpload={true} itemTemplate={itemTemplate} multiple maxFileSize={null} emptyTemplate={<p className="m-0">Drag and drop files to here to upload.</p>}
                cancelOptions={{
                    className: `${uploading && 'p-disabled'}`
                }}
            />
            <Dialog visible={addFileTypesVisible} header={<div className="flex align-items-center">
                <span className="flex align-items-center justify-content-center bg-cyan-100 text-cyan-800 mr-3 border-circle" style={{ width: '32px', height: '32px' }}>
                    <i className="pi pi-info text-lg"></i>
                </span>
                <span className="font-medium text-2xl text-900">Confirm File Types</span>
            </div>} onHide={() => setAddFileTypesVisible(false)} footer={<div className=" border-top-1 surface-border pt-3">
                <Button icon="pi pi-times" onClick={() => setAddFileTypesVisible(false)} label="Cancel" className="p-button-text" />
                <Button icon="pi pi-check" onClick={() => uploadFiles()} label="Upload" disabled={!fileTypesValid} />
            </div >} modal breakpoints={{ '960px': '75vw', '640px': '100vw' }} style={{ width: '80vw', height: '50vw' }}>
                {filesToUpload?.files?.map((file, i)=> {
                    return (
                        <div className="flex flex-row">
                            <div className="mb-5 mr-3">{file.name}</div>
                            <Dropdown className="mb-5 mr-5" options={fileTypeOptions} value={fileTypeMap[i]} onChange={e => modifyFileTypeMap(i, e.value)}/>
                            {/* extra options for paired end */}
                            {fileTypeMap[i] === 'Paired End' && <Dropdown className="mb-5 mr-5" options={pairedEndOptions} value={filePropMap[i]} onChange={e => modifyFilePropMap(i, e.value)} />}
                            {/* extra options for pacbio */}
                            {fileTypeMap[i] === 'Pacbio' && <Dropdown className="mb-5 mr-5" options={pacbioOptions} value={filePropMap[i]} onChange={e => modifyFilePropMap(i, e.value)} />}
                        </div>
                        
                    )
                })}
            </Dialog>
            <DataTable value={files} tableStyle={{ minWidth: '50rem' }} emptyMessage='No files uploaded'>
                <Column field="name" header="Name"></Column>
                {/* <Column field="type" header="Type"></Column> */}
                {/* <Column header="Type" body={typeSelectionTemplate} /> */}
                <Column field="size" header="Size"></Column>
                <Column field="uploadedAt" header="Uploaded at"></Column>
            </DataTable>
            <div className="flex justify-content-end">
                <Button label="Generate New Samples from Files" disabled={!files.length} className='m-1' onClick={() => openSampleGeneration()}/>
                <Button label="Associate Files to Existing Samples" disabled={!files.length} className='m-1' onClick={() => openSampleAssociation()}/>
                <Button label="Finish" disabled={!files.length} className='m-1' onClick={() => navigate('/datasets/files')}/>
            </div>
            {/* Existing Samples Display */}
            <Dialog visible={visible1} header={<div className="flex align-items-center">
                <span className="flex align-items-center justify-content-center bg-cyan-100 text-cyan-800 mr-3 border-circle" style={{ width: '32px', height: '32px' }}>
                    <i className="pi pi-info text-lg"></i>
                </span>
                <span className="font-medium text-2xl text-900">File Association</span>
            </div>} onHide={() => setVisible1(false)} footer={<div className=" border-top-1 surface-border pt-3">
                <Button icon="pi pi-times" onClick={() => setVisible1(false)} label="Cancel" className="p-button-text" />
                <Button icon="pi pi-check" onClick={() => {setVisible1(false); associateFilesToExisting()}} label="Submit" />
            </div >} modal breakpoints={{ '960px': '75vw', '640px': '100vw' }} style={{ width: '80vw', height: '50vw' }}>
                <div className="flex">
                    <TreeTable className="w-50 mr-5" paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} value={existingSampleNodes} responsiveLayout="scroll" selectionMode="single" selectionKeys={selectedNodeKey} onSelectionChange={(e) => setSelectedNodeKey(e.value)}>
                        <Column field="name" header="Sample Name" sortable expander></Column>
                        <Column field="updatedAt" header="Date" sortable body={dateTemplate}></Column>
                        <Column header="Remove" body={(item) => removeTemplate(item, 'existing')}></Column>
                    </TreeTable>
                    <Button icon="pi pi-chevron-left" className="mr-5" onClick={assignFilesToExistingSample}/>
                    <DataTable className="w-25" value={unassignedFiles} responsiveLayout="scroll" stripedRows emptyMessage='No files uploaded'>
                        <Column header="Selected" body={fileSelectorTemplate}/>
                        <Column field="name" header="Sample Name" sortable></Column>
                    </DataTable>
                </div>
            </Dialog>
            { /* New Generated Samples Display */}
            <Dialog visible={visible2} header={<div className="flex align-items-center">
                <span className="flex align-items-center justify-content-center bg-cyan-100 text-cyan-800 mr-3 border-circle" style={{ width: '32px', height: '32px' }}>
                    <i className="pi pi-info text-lg"></i>
                </span>
                <span className="font-medium text-2xl text-900">Generate Samples</span>
            </div>} onHide={() => setVisible2(false)} footer={<div className=" border-top-1 surface-border pt-3">
                <Button icon="pi pi-times" onClick={() => setVisible2(false)} label="Cancel" className="p-button-text" />
                <Button icon="pi pi-check" onClick={() => uploadGeneratedSamples()} label="Submit" />
            </div >} modal breakpoints={{ '960px': '75vw', '640px': '100vw' }} style={{ width: '80vw', height: '50vw' }}>
                <div className="flex flex-column">
                    <div>
                        <InputText value={sampleInput} onChange={(e) => setSampleInput(e.target.value)} className='mr-4 mb-2' />
                        <Button label="Add Sample" onClick={() => addSampleName()} className='mb-1'/>
                    </div>
                    <div className="flex">
                        <TreeTable className="w-50 mr-5" value={sampleNodes} selectionMode="single" selectionKeys={selectedNodeKey} onSelectionChange={(e) => setSelectedNodeKey(e.value)} emptyMessage='No pending samples'>
                            <Column field="name" header="Name" editor={sampleNameEditor} cellEditValidator={requiredValidator} expander></Column>
                            <Column header="Remove" body={removeTemplate}></Column>
                        </TreeTable>
                        <Button icon="pi pi-chevron-left" className="mr-5" onClick={assignFilesToGeneratedSample}/>
                        <DataTable className="w-25" value={unassignedFiles} responsiveLayout="scroll" stripedRows emptyMessage='No unassigned files'>
                            <Column header="Selected" body={fileSelectorTemplate}/>
                            <Column field="name" header="Sample Name" sortable></Column>
                        </DataTable>
                    </div>
                </div>
            </Dialog>
        </div> 
    )
};